import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import UserSearch from '@/shared/components/input/UserSearch';

const messages = defineMessages({
  ChooseEmployeeToAddToTeamX: "Choose the employee you want to add to team '{team}'",
  AddEmployee: 'Add employee',
  AllUsersAreAlreadyInThisTeam: 'All users are already in this team',
});

class SelectEmployeeModal extends Component {
  state = {
    user: undefined,
  };

  userChanged(user) {
    this.setState(state => ({
      ...state,
      user,
    }));
  }
  saveEmployee = () => {
    const { onSave, team } = this.props;
    const { user } = this.state;

    return onSave(user, team);
  };
  render() {
    const { onClose, users, intl, team } = this.props;
    const { user } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.AddEmployee)}
        show
        onClose={onClose}
        disabled={!user}
        onSave={this.saveEmployee}
      >
        <div>
          <p>
            <FormattedMessage
              {...messages.ChooseEmployeeToAddToTeamX}
              values={{ team: `${team.name}` }}
            />
          </p>
          {users && users.length === 0 ? (
            <p className="alert alert-warning">
              <FormattedMessage {...messages.AllUsersAreAlreadyInThisTeam} />
            </p>
          ) : (
            <UserSearch users={users} onChange={selectedUser => this.userChanged(selectedUser)} />
          )}
        </div>
      </OkCancelModal>
    );
  }
}

export default injectIntl(SelectEmployeeModal);
